import React, {useEffect} from 'react';
import b_ from 'b_';
import {Helmet} from 'react-helmet';
import {useSelector, useDispatch} from 'react-redux';

import I18N from 'assets/i18n/brandlift-project';

import {changeOrgFilter} from 'client/common/store/reducers/surveys';
import {Chat} from 'client/common/components/chat';
import Header, {headerMeaningfulSelector} from 'client/common/components/header2';
import {HeaderButton} from 'client/common/components/header2/types';
import Footer from 'client/common/components/footer';
import Modal from 'client/common/components/modal';
import Notifications from 'client/common/components/notifications';
import ListModeContext from 'client/common/contexts/list-mode';
import {getTestBuckets} from 'client/common/store/selectors/user';
import {getListMode} from 'client/common/store/selectors/surveys';
import {getExperiments} from 'client/common/store/selectors/experiments';
import {useCurrentOrg} from 'client/common/hooks/orgs';

import {useRumCounter} from 'client/common/utils/rum';
import {tld} from 'client/common/utils/tld';

import SurveyList from 'client/quicksurvey/list/components/survey-list';

import './list.css';

const i18n = I18N.list;
const b = b_.with('list-page');

export default function ListPage() {
    const experiments = useSelector(getExperiments);
    const testBuckets = useSelector(getTestBuckets);
    const listMode = useSelector(getListMode);

    const headerButtons: HeaderButton[] = ['help', 'create', 'dialog', 'wallet'];

    useRumCounter({
        page: 'quicksurvey.list',
        meaningfulPaintSelector: headerMeaningfulSelector,
        testBuckets
    });

    const orgId = useCurrentOrg();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(changeOrgFilter({orgIds: orgId}));
    }, [dispatch, orgId]);

    return (
        <ListModeContext.Provider value={listMode}>
            <Helmet>
                <title>{i18n.pageTitle}</title>
                <meta property='og:url' content='https://surveys.yandex.ru/quicksurvey/list' />
            </Helmet>
            <Header className={b('header')} buttons={headerButtons} />
            <div className={b()}>
                <SurveyList />
            </div>
            <Chat experiments={experiments} from={`quicksurvey list ${tld.toUpperCase()}`} />
            <Notifications />
            <Modal />
            <Footer />
        </ListModeContext.Provider>
    );
}
